import Axios from "@/Axios";

class AssessmentTypeService{

    async getAssessmentTypes(data={}){
        return await Axios.get('wms.wms.api.assessment_type.get_assessment_types',{
            params:data
        })
    }
    async createAssessmentType(data){
        return await Axios.post('wms.wms.api.assessment_type.create_assessment_type',data)
    }
    async deleteAssessmentType(assessment_type){
        const transformed_assessment_type = assessment_type.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.assessment_type.delete_assessment_types',{data:{assessment_type:transformed_assessment_type}})
    }

}

export default new AssessmentTypeService()